import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import { usePageLocale } from '../../components/i18n/usePageLocale'
import back from "../../assets/images/elements/aboutHeader.jpg";
import article_img from "../../assets/images/articles/7_full.jpeg"
import ArticleLike from '../../components/ArticleLike'

export const Article7FaithfulMessage = () => {
    const ready = usePageLocale('article7');
    if (!ready) return <div style={{ padding: '60px', textAlign: 'center', color: '#999' }}>•••</div>;
    return (

        <section className='text_container_light'>
            <div className='container_100'>
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle7Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle7Title")}</h2>

                            <p>{t("resourceArticle7Author")}</p>

                            <p style={{ fontSize: '13px', color: '#777', fontStyle: 'italic' }}>
                                {t("resourceArticle7ConferenceNote")}
                            </p>

                            <hr />
                            <br/>

                            <img
                                src={article_img}
                                alt={t("resourceArticle7Title")}
                                className="article-img"
                            />

                            <br />
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P1") }} /></p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle7Sec1")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P2") }} /></p>
                            <div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P3") }} />
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P5") }} /></p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle7Sec2")}</h3>
                            <div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P6") }} />
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P7") }} /></p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle7Sec3")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P8") }} /></p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle7Sec4")}</h3>
                            <div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P9") }} />
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P10") }} /></p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle7Sec5")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P11") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P12") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P13") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P14") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P15") }} /></p>

                        </div>

                        {/* ПРАВА КОЛОНКА */}
                        <div>
                            <h3 className='menuColor'>{t("resourceArticle7Sec6")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P16") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P17") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P18") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P19") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P20") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P21") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P22") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P23") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P24") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P25") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P26") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P27") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P28") }} /></p>
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle7Sec7")}</h3>
                            <h4 className='menuColor'>{t("resourceArticle7Sec7b")}</h4>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P29") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P30") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P31") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P32") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P33") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P34") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P35") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P36") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P37") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle7P38") }} /></p>
                            <br/>

                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle7Copyright")}
                            </p>
                            <br/>

                        </div>
                    </div>
                    <ArticleLike articleId='7-herasymchuk-faithful-message' />
                </div>
                <br />
            </div>
        </section>
    )
}
